import React from 'react';
import RouteConfig from './routing/routes';

import './assets/styles/app.less';
import './assets/styles/style.scss';

function App() {
  return (
    <RouteConfig />
  );
}

export default App;
